'use client'

import { createContext, useState, useEffect } from 'react'
import { useRouter, usePathname } from "next/navigation";
import Cookies from "js-cookie"

const MyPlatformContext = createContext()

const MyPlatformProvider = ({ children }) => {
  const [platform, setPlatform] = useState("")
  const router = useRouter()
  const pathname = usePathname();

  const updateCookiePlatform = (newPlatform) => {
    setPlatform(newPlatform);
    Cookies.set('platform', newPlatform)
    router.replace(`/${newPlatform}/home`);
    return;
  };

  useEffect(() => {
    if (pathname.startsWith("/operator")) {
      setPlatform("operator");
    } else {
      setPlatform("my");
    }

  }, [])

  return (
    <MyPlatformContext.Provider
      value={{

        platform,
        setPlatform,

        updateCookiePlatform
      }}
    >
      <>{children}</>
    </MyPlatformContext.Provider>
  )
}

export { MyPlatformContext, MyPlatformProvider }
